/**
 * Shared copy for acknowledging a monitoring alert. The Monitoring table, the
 * dashboard food-alerts rail and the hot-holding detail page hit the same
 * endpoints, so they describe the same outcome the same way (NAU-391).
 */

export const ALERT_ACKNOWLEDGED = "Alert acknowledged";

export const ALERT_ACK_QUEUED = "Saved — this will sync when you reconnect";

export const ALERT_ACK_ERROR =
  "Couldn't acknowledge this alert. Please try again.";
